import React, { Fragment } from 'react';
import { Button, Row } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import CommonSelect from './common/CommonSelect';

const ScalingCapacityScreen = props => {

    const { setCapacity, state, onSubmit } = props;
    const { saveBtnStyles } = props.styles;
    const { currCapacityContainer, contentContainer } = componentStyles;

    return (
        <Fragment>
            <Row style={{ marginLeft: 4 }}>
                <span>
                    <MaterialIcon icon="warning" color="#ffc107" size={20} />
                </span>
                <p style={{ margin: '4px 0 20px 5px', fontSize: 14 }}>
                    {i18n.t('screens:systemControlContainer.capacityWarning')}
                </p>
            </Row>
            <div style={contentContainer}>

                <div style={{ display: 'flex' }}>
                    <CommonSelect
                        changeState={setCapacity}
                        options={[32, 64, 192, 384]}
                        inputName='autoScaling'
                        defaultOptionText={i18n.t('screens:systemControlContainer.selectCapacity')}
                    />
                    <Button
                        color='primary'
                        style={saveBtnStyles}
                        disabled={!state.capacity}
                        onClick={onSubmit}
                    >
                        <MaterialIcon icon="save" color="#fff" size={18} /><span style={{ marginLeft: 5 }}>{i18n.t('common:buttons.save')}</span>
                    </Button>
                </div>
                <div hidden={!state.currCapacity} style={currCapacityContainer}>
                    <div>{i18n.t('screens:systemControlContainer.currCapacityLabel')}:</div>
                    <div style={{ marginLeft: 20 }}>{state.currCapacity}</div>
                </div>
            </div>
        </Fragment>
    );
}

export default ScalingCapacityScreen;

const componentStyles = {
    currCapacityContainer: {
        display: 'flex',
        marginLeft: 200,
        alignItems: 'center'
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'row'
    }
};


// WEBPACK FOOTER //
// ./src/components/systemControl/database/ScalingCapacityScreen.js